import Emotions from './Emotions'

export default Emotions
